import useSWR from "swr";
import { fetcher } from "lib/actions/fetcher";
import { ProjectListModel } from "../types/ProjectListModel";
import { endpointsProjects } from "lib/actions/endpoints/endpointsProjects";

export function useProjects(shouldRequest = true) {
  const { data, isLoading, error, mutate } = useSWR<ProjectListModel[]>(
    shouldRequest && endpointsProjects.list,
    fetcher,
  );

  return {
    projects: data,
    isLoading,
    error,
    mutate,
  };
}
